module.exports = __webpack_public_path__ + "img/jerome.dbc6ad71.jpeg";